(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.analytics.factory.anlaytics-api'

  require('angular')
    .module(MODULE_NAME, [
      require('../../api/async')
    ])
    .provider('AnalyticsAccountApi', analyticsApiProvider)

  function analyticsApiProvider () {
    return {
      $get: analyticsApiService
    }
  }
  analyticsApiService.$inject = ['SdkConfig', 'ThismomentAsyncApi']
  function analyticsApiService (SdkConfig, ThismomentAsyncApi) {
    var API = ThismomentAsyncApi.configureResource(SdkConfig.get('content_cloud_url') + '/api/ccmt/v2/get-analytics-account')
    var AnalyticsAccountApi = {
      getConfig: getConfig
    }

    return AnalyticsAccountApi

    function getConfig (success, error) {
      // NOTE: This all might need to be reworked to match our current config object...
      return API.post({}, {
        account_id: SdkConfig.get('account_id'),
        group_id: SdkConfig.get('group_id'),
        playlist_id: (angular.isObject(SdkConfig.get('playlist'))) ? SdkConfig.get('playlist').playlist_id : undefined,
        cart_hash: SdkConfig.get('cart_hash'),
        solution_hash: SdkConfig.get('solution_hash'),
        solution_id: SdkConfig.get('solution_id'),
        embed_id: SdkConfig.get('embed_id')
      }, success, error)
    }
  };

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/analytics/factory/analytics-api.js